export default __webpack_public_path__ + "static/media/SellerReview.70196e7e.svg";